import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import version from '../version';
import DA from '../store/ReduxAccess';

import { apiFetch, createStdRequest, logWithTime } from '../utils/utils';
import {
  userHasRejectedFileBasedPersistenceInvitationRecently,
  recordUserAcceptanceOfFileStorage,
} from '../store/reduxPersist';

const localStyles = makeStyles((theme) =>
  createStyles({
    root: {
      margin: '16px',
    },
    panelTitle: {
      padding: '8px 0',
      fontSize: '120%',
      borderBottom: '2px solid #4ec',
    },
    allInfoDiv: {
      marginTop: '8px',
    },
    tableLabel: {
      fontWeight: 'bold',
    },
  })
);

const testCallRailPostCall = (role) => {
  const uri = `/api/webhook/callRail/testPostCall/${role}`;
  const request = createStdRequest(uri);
  const actionOnGoodResponse = () => {
    logWithTime('back from call to testPostCall');
  };
  apiFetch(null, request, actionOnGoodResponse);
};

const recordUserAcceptanceOfFileStorageAndShowAlert = () => {
  recordUserAcceptanceOfFileStorage();
  alert('Now--\n   1: Log out.\n   2: Refresh your browser page\n   3: Click "Allow" in the ensuing dialog');
};

const SystemInfoPanel = (props) => {
  const classes = localStyles();

  const firmInfo = DA.getLoggedInFirmInfo();
  const { name: firmName, firmId } = firmInfo;
  const isLocal = window.location.hostname.indexOf('localhost') >= 0;
  const isCallRailTest = firmName.startsWith('CRail Test') || firmName.startsWith('CallRail Test');
  const shouldShowCallRailTestButtons = isLocal || isCallRailTest;
  const shouldShowReverseRejectionPanel = userHasRejectedFileBasedPersistenceInvitationRecently();

  return (
    <div className={classes.root}>
      <div className={classes.panelTitle}>System Information</div>
      <div className={classes.allInfoDiv}>
        <table>
          <tbody>
            <tr>
              <td className={classes.tableLabel}>Version:</td>
              <td>{version}</td>
            </tr>
            <tr>
              <td className={classes.tableLabel}>Account:</td>
              <td>{firmName}</td>
              <td className={classes.tableLabel}>Firm Id:</td>
              <td>{firmId}</td>
            </tr>
          </tbody>
        </table>
        {shouldShowReverseRejectionPanel && (
          <div>
            <div style={{ padding: '12px', width: '600px' }}>
              You can (and probably should) choose to allow Chrome to use some of your disk space to back up data so
              that Refresh-ing the browser page will not crash the CRM. Click <b>Allow Hidden File Storage</b> to do
              this. The new functionality will then be enabled after you (1) log out and (2) refresh your browser page
              You will then be given another chance to <b>Allow</b> rather than <b>Block</b> it.
            </div>
            <div style={{ width: '600px', textAlign: 'center' }}>
              <button onClick={() => recordUserAcceptanceOfFileStorageAndShowAlert()}>Allow Hidden File Storage</button>
            </div>
          </div>
        )}
        {shouldShowCallRailTestButtons && (
          <div style={{ marginTop: '30px', padding: '20px' }}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <button onClick={() => testCallRailPostCall('Client')}>Fake CallRail Call from a Client</button>
                  </td>
                  <td>
                    <button onClick={() => testCallRailPostCall('EmergencyContact')}>
                      Fake CallRail Call from an Emergency Contact
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => testCallRailPostCall('ReferralContact')}>
                      Fake CallRail Call from a Referral Contact
                    </button>
                  </td>
                  <td>
                    <button onClick={() => testCallRailPostCall('ReferralCompany')}>
                      Fake CallRail Call from a Referral Company
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => testCallRailPostCall('Unknown')}>
                      Fake CallRail Call from Unknown Number
                    </button>
                  </td>
                  <td>
                    <button onClick={() => testCallRailPostCall('Blocked')}>Fake Blocked Caller ID</button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <button onClick={() => testCallRailPostCall('NoResourceId')}>Fake Firm w/ No Resource ID</button>
                  </td>
                  <td>
                    <button onClick={() => testCallRailPostCall('NoInfo')}>Fake Firm w/ no CallRail Info</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemInfoPanel;
